import Image from '../portal/common/Image/Image';
import { registerComponent } from './Registry';
import ButtonWidget from './components/ButtonWidget';
import ColumnLayout from './components/ColumnLayout';
import ConditionalWidget from './components/ConditionalWidget';
import FullPageLayout from './components/FullPageLayout';
import GenericTabs from './components/TabsWidget';
import RowLayout from './components/RowLayout';
import StateHolder from './components/StateHolder';
import ThreeColumnLayout from './ThreeColumnLayout';
let isInitialized = false;
const initRegistry = () => {
    if (isInitialized) {
        return;
    }
    // Some of the components are registered here to avoid cyclic dependency issues
    // between them and the Renderer component.
    registerComponent('Image', Image);
    registerComponent('Button', ButtonWidget);
    registerComponent('RowLayout', RowLayout);
    registerComponent('ColumnLayout', ColumnLayout);
    registerComponent('ConditionalWidget', ConditionalWidget);
    registerComponent('FullPageLayout', FullPageLayout);
    registerComponent('StateHolder', StateHolder);
    registerComponent('Tabs', GenericTabs);
    registerComponent('ThreeColumnLayout', ThreeColumnLayout);
    isInitialized = true;
};
export default initRegistry;
//# sourceMappingURL=RegistryInit.js.map